"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
//long imports are intentional (imports react with '@wix/social-groups-common')
var loggers_1 = require("@wix/social-groups-common/dist/src/loggers");
var BaseWidgetController_1 = require("@wix/social-groups-common/dist/src/BaseWidgetController");
var group_1 = require("../group");
var feed_1 = require("../feed");
var members_1 = require("../members");
var MainController = /** @class */ (function (_super) {
    tslib_1.__extends(MainController, _super);
    function MainController(controllerConfig, experiments) {
        var _this = _super.call(this, controllerConfig) || this;
        _this.experiments = experiments;
        _this.setLogger(controllerConfig);
        _this.controllers = [
            new group_1.GroupController(controllerConfig, experiments),
            new members_1.MembersController(controllerConfig),
            new feed_1.FeedController(controllerConfig),
        ];
        return _this;
    }
    MainController.prototype.pageReady = function ($w, wixAPI) {
        var logLevel = this.getLogLevel(this.controllerConfig);
        this.controllerConfig.setProps({
            logLevel: logLevel,
        });
        return Promise.all(this.controllers.map(function (controller) { return controller.pageReady($w, wixAPI); })).catch(function (e) {
            console.log('Controllers page ready error', e);
        });
    };
    MainController.prototype.setLogger = function (controllerConfig) {
        var logLevel = this.getLogLevel(controllerConfig);
        MainController.logger = new loggers_1.ConsoleLogger(logLevel);
    };
    MainController.prototype.getLogLevel = function (controllerConfig) {
        var logLevel = loggers_1.LogLevel.NONE;
        try {
            if (controllerConfig.wixCodeApi.location.query.debug === 'true') {
                logLevel = loggers_1.LogLevel.DEBUG;
            }
            if (controllerConfig.wixCodeApi.location.query.trace === 'true') {
                logLevel = loggers_1.LogLevel.TRACE;
            }
        }
        catch (e) { }
        return logLevel;
    };
    MainController.logger = new loggers_1.ConsoleLogger(loggers_1.LogLevel.NONE);
    return MainController;
}(BaseWidgetController_1.BaseWidgetController));
exports.MainController = MainController;
function getLogger() {
    return MainController.logger;
}
exports.getLogger = getLogger;
//# sourceMappingURL=MainController.js.map